// Centralized Driver.js helper to ensure consistent tour dialogs
import { driver } from "driver.js";

export function createAppTour(options = {}) {
  const defaultOptions = {
    // showProgress: false,
    showButtons: ["next", "previous"],
    progressText: "{{current}} of {{total}}",
    nextBtnText: "Next",
    prevBtnText: "Previous",
    doneBtnText: "Finish",
    overlayColor: "rgba(0, 0, 0, 0.7)",
    smoothScroll: true,
    allowClose: false,
    // Side/overlay click must not dismiss the guide
    overlayClickBehavior: () => {},
    disableActiveInteraction: false,
    popoverClass: "driverjs-theme-app",
    animate: true,
  };

  const merged = { ...defaultOptions, ...options };
  const buttons = Array.isArray(merged.showButtons)
    ? merged.showButtons.slice()
    : ["next", "previous"];

  // Respect explicit allowClose: false (Quick Guides / locked tours).
  // Only force-close UX when the caller opts in.
  if (merged.allowClose === true) {
    if (!buttons.includes("close")) buttons.push("close");
    if (!merged.closeBtnText) merged.closeBtnText = "Close";
  } else {
    merged.allowClose = false;
    if (merged.overlayClickBehavior == null) {
      merged.overlayClickBehavior = () => {};
    }
    const closeIdx = buttons.indexOf("close");
    if (closeIdx >= 0) buttons.splice(closeIdx, 1);
  }

  merged.showButtons = buttons;

  const instance = driver(merged);

  // Utilities to manage the global bottom-centered Skip button
  // Removed global bottom-center Skip button per latest request

  return instance;
}

export function buildStep(elementSelector, { title, description, side = "bottom", align = "start", nextBtnText, prevBtnText, doneBtnText, onNextClick, onPrevClick } = {}) {
  return {
    element: elementSelector,
    popover: {
      title,
      description,
      side,
      align,
      ...(nextBtnText ? { nextBtnText } : {}),
      ...(prevBtnText ? { prevBtnText } : {}),
      ...(doneBtnText ? { doneBtnText } : {}),
      ...(onNextClick ? { onNextClick } : {}),
      ...(onPrevClick ? { onPrevClick } : {}),
    },
  };
}
